import i18n from '@/i18n';

export default class WebFiscalService {

    constructor() {
    }

    async init(options = {}) {
    }

    async chooseCertificate(password, pac) {
        return { error: this.formatError() }
    }

    async verifyPin(pin, sdc) {
        return { error: this.formatError() }
    }

    async createInvoice(invoice, sdc) {
        return { error: this.formatError() }
    }

    async getInvoice(requestId, sdc) {
        return { error: this.formatError() }
    }

    async getEnvironmentParameters(sdc) {
        return { error: this.formatError() }
    }

    async getStatus(sdc) {
        return { error: this.formatError() }
    }

    async getAttention(sdc) {
        return { error: this.formatError() }
    }

    async getUiData(sdc) {
        return { error: this.formatError() }
    }

    async storeLocalAuditFiles(sdc) {
        return { error: this.formatError() }
    }

    async executeCommandsFromStorage(sdc) {
        return { error: this.formatError() }
    }

    formatError() {
        return { code: 'not_possible_from_web_app', message: i18n.t('sdc.status.not_possible_from_web_app'), response: { data: null } }
    }
}
